module.exports = __webpack_public_path__ + "static/WY-d747cf9fa0f94d3410a58b7977909ee2.svg";